'use strict';

var BaseLayer = require('./base/BaseLayer');
var Geometry = require('../utils/Geometry');
var PathEventMixin = require('./mixins/PathEventMixin');
var PathStyleMixin = require('./mixins/PathStyleMixin');

var PolylineLayer = BaseLayer.extend([PathEventMixin, PathStyleMixin, {

  initialize: function () {
    this.registerPathEventListeners();
  },

  setStyle: function (style) {
    this.leafletLayer.setStyle(style);
  },

  _getPopupLatLng: function () {
    var leafletLayer = this.leafletLayer;
    var latlngs = leafletLayer.getLatLngs();

    // return the center latlng
    return latlngs[Math.ceil((latlngs.length-1)/2)];
  },

  /**
   * Set leafletLayer style to highlighted
   */
  _setStateStyleToActive: function () {
    var style = this.styles.active;
    style = this.mergeCurrentStyleWithStateStyle(style);
    this.setStyle(style);
  },

  /**
   * Set leafletLayer style to its default
   */
  _setStateStyleToDefault: function () {
    var style = this.styles.default;
    style = this.mergeCurrentStyleWithStateStyle(style);
    this.setStyle(style);
  },

  /**
   * Set leafletLayer style to dimmed
   */
  _setStateStyleToDim: function () {
    var style = this.styles.dim;
    style = this.mergeCurrentStyleWithStateStyle(style);
    this.setStyle(style);
  },

  _updateMeasurements: function () {
    var distance = Geometry.lineDistance(this.layer.data, 'meters');
    this.layer.distance = distance;
    this.layer.data.properties.distance = distance;
    this.leafletLayer.fire('measurements:updated');
  }

}]);

module.exports = PolylineLayer;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/edit/PolylineLayer.js